import React from 'react';
import { Stack } from '@mui/material';
import { DataAccessProvider } from '@constants/constants';
import AppsflyerAccountForm from './DataAccessForms/AppsflyerAccountForm';
import AdjustAccountForm from './DataAccessForms/AdjustAccountForm';
import BigQueryAccountForm from './DataAccessForms/BigQueryAccountForm';
import GCSBucketAccountForm from './DataAccessForms/GCSBucketAccountForm';
import S3BucketAccountForm from './DataAccessForms/S3BucketAccountForm';
import MySQLAccountForm from './DataAccessForms/MySQLAccountForm';
import SnowflakeAccountForm from './DataAccessForms/SnowflakeAccountForm';
import GoogleDriveAccountForm from './DataAccessForms/GoogleDriveAccountForm';
import AggregatedCohortDataForm from './DataAccessForms/AggregatedCohortDataForm';
import { DataSourceDetails } from '../ModifyPermissions/components/DataSourceCard';

interface DataAccessSourceFieldsProps {
  dataAccessSource: DataAccessProvider | null;
  newGameData: DataSourceDetails;
  handleUpdateNewGameData: (key: string, value: string) => void;
  onValidityChange?: (isValid: boolean) => void;
  disabled?: boolean;
}

const DataAccessSourceFields: React.FC<DataAccessSourceFieldsProps> = ({
  dataAccessSource,
  newGameData,
  handleUpdateNewGameData,
  onValidityChange,
  disabled = false,
}) => {
  switch (dataAccessSource) {
    case DataAccessProvider.APPS_FLYER:
      return (
        <AppsflyerAccountForm
          newGameData={newGameData}
          handleUpdateNewGameData={handleUpdateNewGameData}
          onValidityChange={onValidityChange}
          disabled={disabled}
        />
      );
    case DataAccessProvider.ADJUST:
      return (
        <AdjustAccountForm
          newGameData={newGameData}
          handleUpdateNewGameData={handleUpdateNewGameData}
          onValidityChange={onValidityChange}
          disabled={disabled}
        />
      );
    case DataAccessProvider.BIGQUERY:
      return (
        <Stack gap={'1rem'}>
          <BigQueryAccountForm
            connectionDetails={newGameData?.connectionDetails}
            refreshRequired={Boolean(newGameData?.refreshRequired)}
            handleUpdateNewGameData={handleUpdateNewGameData}
            onValidityChange={onValidityChange}
            disabled={disabled}
          />
        </Stack>
      );
    case DataAccessProvider.GCS:
      return (
        <Stack gap={'1rem'}>
          <GCSBucketAccountForm
            connectionDetails={newGameData?.connectionDetails}
            refreshRequired={Boolean(newGameData?.refreshRequired)}
            handleUpdateNewGameData={handleUpdateNewGameData}
            onValidityChange={onValidityChange}
            disabled={disabled}
          />
        </Stack>
      );
    case DataAccessProvider.S3:
      return (
        <Stack gap={'1rem'}>
          <S3BucketAccountForm
            connectionDetails={newGameData?.connectionDetails}
            refreshRequired={Boolean(newGameData?.refreshRequired)}
            handleUpdateNewGameData={handleUpdateNewGameData}
            onValidityChange={onValidityChange}
            disabled={disabled}
          />
        </Stack>
      );
    case DataAccessProvider.MYSQL:
      return (
        <Stack gap={'1rem'}>
          <MySQLAccountForm
            connectionDetails={newGameData?.connectionDetails}
            refreshRequired={Boolean(newGameData?.refreshRequired)}
            handleUpdateNewGameData={handleUpdateNewGameData}
            onValidityChange={onValidityChange}
            disabled={disabled}
          />
        </Stack>
      );
    case DataAccessProvider.SNOWFLAKE:
      return (
        <Stack gap={'1rem'}>
          <SnowflakeAccountForm
            connectionDetails={newGameData?.connectionDetails}
            refreshRequired={Boolean(newGameData?.refreshRequired)}
            handleUpdateNewGameData={handleUpdateNewGameData}
            onValidityChange={onValidityChange}
            disabled={disabled}
          />
        </Stack>
      );
    case DataAccessProvider.GOOGLE_DRIVE:
      return (
        <Stack gap={'1rem'}>
          <GoogleDriveAccountForm
            connectionDetails={newGameData?.connectionDetails}
            refreshRequired={Boolean(newGameData?.refreshRequired)}
            handleUpdateNewGameData={handleUpdateNewGameData}
            onValidityChange={onValidityChange}
            disabled={disabled}
          />
        </Stack>
      );
    case DataAccessProvider.AGGREGATED_DATA:
      return (
        <Stack gap={'1rem'}>
          <AggregatedCohortDataForm
            connectionDetails={newGameData?.connectionDetails}
            refreshRequired={Boolean(newGameData?.refreshRequired)}
            handleUpdateNewGameData={handleUpdateNewGameData}
            onValidityChange={onValidityChange}
            disabled={disabled}
          />
        </Stack>
      );
    default:
      return null;
  }
};

export default DataAccessSourceFields;
